import * as i0 from "@angular/core";
var GAType;
(function (GAType) {
    GAType["JS"] = "js";
    GAType["Config"] = "config";
    GAType["Event"] = "event";
})(GAType || (GAType = {}));
export class GAEventData {
}
export class AnalyticsService {
    constructor() {
        // define gtag placeholder: if not defined
        const _window = window;
        if (!_window.gtag) {
            _window.dataLayer = _window.dataLayer || [];
            _window.gtag = function () { _window.dataLayer.push(arguments); };
        }
    }
    // setup analytics for SPA
    init(analyticsId) {
        this.analyticsId = analyticsId;
        // config
        this.gtag(GAType.JS, new Date());
        this.gtag(GAType.Config, analyticsId, {
            'send_page_view': false
        });
    }
    logPageView(path) {
        this.gtag(GAType.Config, this.analyticsId, {
            'page_path': path
        });
    }
    logEvent(action, actionData) {
        this.gtag(GAType.Event, action, actionData);
    }
    gtag(...args) {
        window.gtag(...args);
    }
}
AnalyticsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AnalyticsService_Factory() { return new AnalyticsService(); }, token: AnalyticsService, providedIn: "root" });
